import React from 'react'
import icon from '../../img/icon/logo-mini.png';

export default function LogoMini() {
   return (
      <div>
         <img src={icon} alt="" />
      </div>
   )
}
